import { render, staticRenderFns } from "./trainTrendInfo.vue?vue&type=template&id=c447701c&scoped=true"
import script from "./trainTrendInfo.vue?vue&type=script&lang=js"
export * from "./trainTrendInfo.vue?vue&type=script&lang=js"
import style0 from "./trainTrendInfo.vue?vue&type=style&index=0&id=c447701c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c447701c",
  null
  
)

export default component.exports